import { render, staticRenderFns } from "./orderPay.vue?vue&type=template&id=45ad5712&scoped=true&"
import script from "./orderPay.vue?vue&type=script&lang=js&"
export * from "./orderPay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45ad5712",
  null
  
)

component.options.__file = "src/demo/packageMall/orderPay.vue"
export default component.exports